module.exports = __webpack_public_path__ + "static/media/selo.a96a4832.svg";